import { IApplicationState } from '../../types/redux';
import { ETab } from '../../types/tab';

export const getIsQuestionTab = (state: IApplicationState): boolean => {
  return state.tabs === ETab.Questions;
};
